export const themeBorderRadius = {
  DEFAULT: '5px',
  small: '2px',
  none: '0px',
  full: '100%'
} as const;
